module.exports = "../fonts/hotel_wifi_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_wifi_icon.svg
// module id = 442
// module chunks = 0